import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {GRAY_DARKER} from 'ui-library/Colors';

import BenchlingIcon from './BenchlingIcon';

export interface InfoIconProps {
  isFilled?: boolean;
}

/**
 * Informational icon.
 *
 * @param props.isFilled When true, gives icon gray background, rather than clear.
 */
export default function InfoIcon({isFilled = true}: InfoIconProps): JSX.Element {
  return (
    <BenchlingIcon icon={isFilled ? 'info-circle' : 'info-circle-outline'} className={css(styles.infoIcon)} />
  );
}

const styles = StyleSheet.create({
  infoIcon: {
    color: GRAY_DARKER,
  },
});
